import { FC } from 'react';

import Callout from 'components/_core/Callout';

interface WarningProps {
  title: string;
  description: string;
}

const Warning: FC<WarningProps> = ({ description, title }) => {
  return (
    <Callout variant="warning">
      <Callout.Title>{title}</Callout.Title>
      <Callout.Content>{description}</Callout.Content>
    </Callout>
  );
};

export default Warning;
